import React, { useRef, useState, useEffect } from 'react';
import cn from 'classnames';
import * as PropTypes from 'prop-types';
import { CSSTransition } from 'react-transition-group';
import { useDispatch } from 'react-redux';

import { useAuth0 } from '../../context/auth0';
import { ModalCustomerSignup, ModalOneTap } from '../modals';
import { action_openModalLikeListing } from '../data/isOpenModalLikeListing';

import { useClickEventOnDocument } from '../../hooks/useClickEventOnDocument';
import pages from '../../define/pages';
import { QUERY_PARAMS } from '../../../constants';
import { getFlagCodeFromLanguage } from '../../../main';

import UserProfileWidget from './UserProfileWidget';
import CategoriesDropdown from './CategoriesDropdown';
import LanguagesDropdown from './LanguagesDropdown';
import SmartSearchTermsAutocomplete from '../SearchForm/SmartSearchTermsAutocomplete';

import Icon from '@iconify/react';
import iconHeart from '@iconify-icons/mdi/cards-heart';
import iconHistory from '@iconify-icons/mdi/history';
import iconCompass from '@iconify-icons/mdi/compass-outline';
import iconChevronDown from '@iconify-icons/mdi/chevron-down';

const SmartViewDesktop = (props) => {

  const {
    isAuthenticated,
    isLoading,
    loginWithRedirect,
    logout,
    user,
  } = useAuth0();

  const dispatch = useDispatch();

  const baseClass = 'navbar__menu';
  const itemClass = baseClass + '__item';

  const [isLanguagesDropdownOpen, setIsLanguagesDropdownOpen] = React.useState(
    false
  );

  const [
    isCategoriesDropdownOpen,
    setIsCategoriesDropdownOpen,
  ] = React.useState(false);

  useClickEventOnDocument([isCategoriesDropdownOpen], () => {
    isCategoriesDropdownOpen && setIsCategoriesDropdownOpen(false);
  });

  useClickEventOnDocument([isLanguagesDropdownOpen], () => {
    isLanguagesDropdownOpen && setIsLanguagesDropdownOpen(false);
  });

  const [selectedSearchTerm, setSelectedSearchTerm] = useState(
    props.initialSearchTerm
  );
  const handleSearchTermChange = (searchTermObj) => {
    setSelectedSearchTerm(searchTermObj.title);
  };

  const formRef = useRef(null);
  useEffect(() => {
    if (selectedSearchTerm) {
      formRef.current.submit();
    }
  }, [selectedSearchTerm]);

  const transitionProps = {
    classNames: baseClass,
    in: !isLoading,
    mountOnEnter: true,
    unmountOnExit: true,
    appear: true,
    timeout: 200,
  };
  let language_fullname = 'Italiano';
  freedomeConfig.languages.map((language, index) => {
    if (language.code == freedomeConfig.locale)
      language_fullname = language.fullname
  })
  const wpmlItemClass = `${cn(itemClass)} wpml-language-switcher-menu`;
  return (
    <CSSTransition {...transitionProps}>
      <ul className={cn(baseClass)} data-label="" data-widget="navigation-menu">
        <li key="search" className={cn(itemClass, "search-bar-container")}>
          <div
            className={cn('search-section__location-input', {
              'search-section__location-input--icon-primary': !!selectedSearchTerm,
            })}
          >
            <form ref={formRef} className={'region-form'} action={pages.catalogue} method={'get'}>
              <SmartSearchTermsAutocomplete
                selectedSearchTerm={selectedSearchTerm}
                onSearchTermSelect={handleSearchTermChange}
                selectFirstSuggestionOnBlur={false}
              />
            </form>
          </div>
        </li>
        <li key="languages" className={wpmlItemClass}>
          <span onClick={() => setIsLanguagesDropdownOpen(true)}>
            {' '}
            {language_fullname}
            {' '}
            <Icon icon={iconChevronDown} className="icon" />{' '}
          </span>
          <LanguagesDropdown isOpen={isLanguagesDropdownOpen} />
        </li>
        <li key="categories" className={cn(itemClass)}>
          <span onClick={() => setIsCategoriesDropdownOpen(true)}>
            {app_main_wpml.activity}
            <Icon icon={iconCompass} className="icon" />
          </span>
          <CategoriesDropdown isOpen={isCategoriesDropdownOpen} ignoredCategories={props.ignoredCategories} />
        </li>

        <li key="wishlist" className={cn(itemClass)}>
          {
            isAuthenticated ? (
              <a
                href={pages.wishList}
              >
                {app_main_wpml.favourite}
                <Icon icon={iconHeart} className="icon" />
              </a>
            ) : (
              <span
                onClick={() => { dispatch(action_openModalLikeListing()); }}
              >
                {app_main_wpml.favourite}
                <Icon icon={iconHeart} className="icon" />
              </span>
            )
          }
        </li>

        <li key="history" className={cn(itemClass)}>
          <a href={pages.historyList}>
            {app_main_wpml.search_history}
            <Icon icon={iconHistory} className="icon" />
          </a>
        </li>

        {!isAuthenticated && (
          <React.Fragment>
            <li
              key="login"
              className={cn(itemClass)}
              onClick={(e) => {
                loginWithRedirect(e);
              }}
            >
              <span>{app_main_wpml.login}</span>
            </li>
            <ModalCustomerSignup key="register" layout="navbar" prefixesAreVisible={props.prefixesAreVisible} />
            <ModalOneTap key="otp" />
          </React.Fragment>
        )}

        {isAuthenticated && (
          <UserProfileWidget
            classes={cn(itemClass)}
            pages={pages}
            user={user}
            logoutHandler={logout}
          />
        )}
      </ul>
    </CSSTransition>
  );
};

SmartViewDesktop.propTypes = {
  prefixesAreVisible: PropTypes.string
};

export default SmartViewDesktop;
